import { Button, Stack } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { snakeCase } from 'lodash';

type Props = {
  setSection: (section: string) => void;
  pages: { key: string; label: string }[];
};

export default function NavDesktop({ setSection, pages }: Props) {
  const handleClick = (id: string) => {
    const el = document.getElementById(id);

    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
    }
  };

  return (
    <Stack direction="row" spacing={2}>
      {pages.map((page) => (
        <Button
          key={page.key}
          onClick={() => {
            const id = snakeCase(page.key);
            if (page.key === 'Floor Plans' || page.key === '3D Tour') {
              setSection(id);
            }
            setTimeout(() => {
              handleClick(id);
            }, 0);
          }}
          sx={{
            color: 'gray',
            textTransform: 'unset',
            '&:hover': {
              color: 'black',
              background: alpha('#000', 0.1),
            },
          }}
        >
          {page.label}
        </Button>
      ))}
    </Stack>
  );
}
